import Radio from "backbone.radio";

/**
 * This channel is for communication with the game
 * example: do something when an object on the stage is selected
 */

export default Radio.channel("game");
